import { render, staticRenderFns } from "./historyImport.vue?vue&type=template&id=19ecb29e&"
import script from "./historyImport.vue?vue&type=script&lang=js&"
export * from "./historyImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports